import { MatomoSiteIds } from '@ahd/shared/types/tracking/matomo/sites';
import { useEffect } from 'react';
import { DebugLevel, TrackingProvider } from '../../_configs/types';
import { useSettingsContext } from '../../context/settings';
import checkUndefinedOrNull from '../../utils/tools/checkUndefinedOrNull';

export default function AnalyticsProvider() {
    const settings = useSettingsContext();

    useEffect(() => {
        if (settings?.general?.debug === DebugLevel.TRACKING || settings?.general?.debug >= DebugLevel.INFO) {
            console.log('AnalyticsProvider - Initializing');
        }

        if (settings?.api?.tracking?.provider === TrackingProvider.ETracker) {
            if (checkUndefinedOrNull(document.getElementById('_etLoader'))) {
                if (settings?.general?.debug === DebugLevel.TRACKING || settings?.general?.debug >= DebugLevel.INFO) {
                    console.log('AnalyticsProvider - Setting up ETracker...');
                }
                const etLoader = document.createElement('script');
                etLoader.async = true;
                etLoader['data-block-cookies'] = 'true';
                etLoader['data-ecommerce-grabber'] = 'true';
                etLoader['data-secure-code'] = settings?.api?.tracking?.apiKey;
                etLoader.id = '_etLoader';
                etLoader.src = 'https://code.etracker.com/code/e.js';
                document.body.appendChild(etLoader);
            }
            if (checkUndefinedOrNull(document.getElementById('_etSettings'))) {
                const etSettings = document.createElement('script');
                etSettings.id = '_etSettings';
                etSettings.innerHTML = `// var et_pagename = "";
                    // var et_areas = "";
                    // var et_tval = 0;
                    // var et_tsale = 0;
                    // var et_tonr = "";
                    // var et_basket = "";`;
                document.body.appendChild(etSettings);
            }
        } else {
            if (checkUndefinedOrNull(document.getElementById('ahdOcto'))) {
                window._paq = window?._paq || [];
                window?._paq?.push(['disableCookies']);
                window?._paq?.push(['trackPageView']);
                window?._paq?.push(['setTrackerUrl', 'https://octo.autohaus-digital.de/matomo.php']);
                window?._paq?.push(['setSiteId', MatomoSiteIds.AHD]);

                if (settings?.general?.debug === DebugLevel.TRACKING || settings?.general?.debug >= DebugLevel.INFO) {
                    console.log('AnalyticsProvider - Setting up Octo...');
                }
                const ahdOcto = document.createElement('script');
                ahdOcto.async = true;
                ahdOcto.id = 'ahdOcto';
                ahdOcto.src = 'https://octo.autohaus-digital.de/matomo.js';
                document.body.appendChild(ahdOcto);
            }
        }
    }, [settings?.api?.tracking?.apiKey, settings?.api?.tracking?.provider, settings?.general?.debug]);

    return null;
}
